import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../static/icons/verified_review.svg'


const _hoisted_1 = { class: "review" }
const _hoisted_2 = { class: "review__container" }
const _hoisted_3 = { class: "review__container-author-wrapper" }
const _hoisted_4 = { class: "review__container-author" }
const _hoisted_5 = { class: "review__container-initials" }
const _hoisted_6 = {
  key: 0,
  class: "review__container-badge-wrapper"
}
const _hoisted_7 = { class: "review__container-badge" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "review__container-badge-icon",
  src: _imports_0
}, null, -1)
const _hoisted_9 = { class: "review__container-badge-tooltip" }
const _hoisted_10 = { class: "review__author-container" }
const _hoisted_11 = { class: "review__author-box" }
const _hoisted_12 = { class: "review__author-name" }
const _hoisted_13 = { class: "review__author-review-rating" }
const _hoisted_14 = { class: "review__author-review-date" }
const _hoisted_15 = { class: "review__container-author-translate" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "review__author-flag-placeholder"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "review__container-text" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "review__line" }, null, -1)

import { onMounted, computed, ref } from 'vue';

import useWebsiteText from '@/composables/useWebsiteTexts';
import { Hit, getReviewsContext } from '@/composables/useReviews';

import { languageToCountryMap } from '@/helpers/mapping';
import { convertToIsoDate } from '@/utils';

import ReviewStars from './ReviewStars.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  props: {
    review: null
  },
  setup(__props: any) {

const props = __props as {
  review: Hit;
}



const { websiteText } = useWebsiteText();
const { parseReviewRating } = getReviewsContext();

const maxNumberOfWords = 25;

const isCommentTooLong = ref(false);
const readMore = ref(false);
const seeTranslatedReview = ref(true);

const authorName = computed(() => {
  return props.review.author.name
    .split(' ')
    .slice(0, 2)
    .filter(Boolean)
    .map((word, index) => {
      if (index === 0) return word.trim();
      return `${word.trim().charAt(0)}.`;
    })
    .join(' ');
});

const nameInitials = computed(() => {
  return authorName.value
    .split(' ')
    .slice(0, 1)
    .map((word) => word.charAt(0))
    .join('');
});

const isTranslated = computed(() => !!props.review.translation.productRating);

const countryText = computed(() =>
  isTranslated.value && props.review.language
    ? `${websiteText('review_translatedfrom').value} ${
        websiteText(`review_language${props.review.language}`).value
      }`
    : websiteText(`review_language${props.review.language}`).value
);

const comment = computed(() => {
  if (props.review.translation.productRating && seeTranslatedReview.value)
    return props.review.translation.productRating;
  return props.review.productRating.comment;
});

const commentToDisplay = computed(() => {
  if (isCommentTooLong.value && !readMore.value) {
    return comment.value.split(/\s+/).slice(0, maxNumberOfWords).join(' ');
  }

  return comment.value;
});

function displayEntireComment() {
  readMore.value = true;
}

function toggleTranslatedReview() {
  seeTranslatedReview.value = !seeTranslatedReview.value;
}

onMounted(() => {
  if (comment.value.split(/\s+/).length > maxNumberOfWords) {
    isCommentTooLong.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_unref(nameInitials)) + " ", 1),
            (__props.review.verified)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(websiteText)('review_verifiedtransaction').value), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(authorName)), 1),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(ReviewStars, {
                  rating: _unref(parseReviewRating)(__props.review.productRating.value)
                }, null, 8, ["rating"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(convertToIsoDate)(__props.review.createdAt)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          (__props.review.language)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "review__author-flag",
                src: 
              require(`../../static/flags/${
                _unref(languageToCountryMap)[__props.review?.language]
              }.svg`)
            
              }, null, 8, _hoisted_16))
            : (_openBlock(), _createElementBlock("div", _hoisted_17)),
          _createElementVNode("span", {
            class: _normalizeClass({
              'review__container-author-language':
                _unref(isTranslated) && __props.review.language,
            })
          }, _toDisplayString(_unref(countryText)), 3),
          (_unref(isTranslated) && __props.review.language)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "•"))
            : _createCommentVNode("", true),
          (_unref(isTranslated) && __props.review.language)
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                class: "review__container-author-translate-text",
                onClick: toggleTranslatedReview
              }, _toDisplayString(seeTranslatedReview.value
                ? _unref(websiteText)('review_seeoriginal').value
                : _unref(websiteText)('review_seetranslation').value), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createTextVNode(_toDisplayString(_unref(commentToDisplay)) + " ", 1),
        (isCommentTooLong.value && !readMore.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: displayEntireComment,
              class: "review__container-text-read-more"
            }, _toDisplayString(_unref(websiteText)('review_readmore').value) + "... ", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_20
  ]))
}
}

})